import React from 'react';

const AWS_Cloud_Certification = () => {
  return (
    <div>
      <h1>AWS_Cloud_Certification</h1>
      <p>This is the AWS_Cloud_Certification component.</p>
    </div>
  );
};

export default AWS_Cloud_Certification;
